/**useShowMessage.js
 * Composable для отображения диалоговых сообщений.
 * Заменяет MixinShowMessage.
 */
import { ref } from 'vue';

export function useShowMessage() {
  const header = ref('Сообщение');
  const isDialogMessage = ref(false);
  const message = ref('');

  function showMessage(newHeader, newMessage) {

    header.value = newHeader ? newHeader : 'Сообщение';
    message.value = newMessage;
    isDialogMessage.value = true;
  }

  return {
    header,
    isDialogMessage,
    message,
    showMessage,
  };
}
